<template>
	<modal v-model="legalInfoModal.visible" :title="legalInfoModal.titleLangKey ? $t(legalInfoModal.titleLangKey) : null" highest-order>
		<lazy-server-content v-if="legalInfoModal.key" :action="`/v1/settings/${legalInfoModal.key}`" as-guest access="value"/>
	</modal>
</template>

<script setup lang="ts">
	import {useGlobalStore} from "../../store/global";

	const {legalInfoModal} = useGlobalStore();
</script>